import type { PortfolioAmountTaxValue } from '@mews-commander/data-access';

export function mapTaxRates(taxations: PortfolioAmountTaxValue[], taxRateCodes: string[]): Record<string, string> {
    return taxRateCodes.reduce<Record<string, string>>((acc, taxRateCode) => {
        const taxation = taxations.find((t) => t.taxRateCode === taxRateCode);
        if (taxation && typeof taxation.taxationCode === 'string') {
            acc[taxation.taxationCode] = taxRateCode;
        }
        return acc;
    }, {});
}
